module.exports = __webpack_public_path__ + "img/logo_blender.68f29551.png";